import { render, staticRenderFns } from "./AdvertBillboardForm.vue?vue&type=template&id=887d3b88&scoped=true&"
import script from "./AdvertBillboardForm.vue?vue&type=script&lang=js&"
export * from "./AdvertBillboardForm.vue?vue&type=script&lang=js&"
import style0 from "./AdvertBillboardForm.vue?vue&type=style&index=0&id=887d3b88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887d3b88",
  null
  
)

export default component.exports